<template>
  <div id="index">
    <el-container>
      <el-main>
        <div class="KPIDiv">
          <el-date-picker
            style="margin-bottom: 12px; float: right; width: 130px"
            v-model="monthData"
            type="month"
            align="right"
            unlink-panels
            value-format="yyyy-MM"
            :picker-options="pickerBeginDateBefore"
            :default-value="timeDefaultShow"
            :clearable="false"
            @blur="changeMonth"
          >
          </el-date-picker>
          <div class="clear"></div>
          <div class="el-row" style="margin-left: -12px; margin-right: -12px">
            <div
              class="el-col el-col-24 el-col-xs-24 el-col-sm-24 el-col-md-24"
              style="padding-left: 12px; padding-right: 12px"
            >
              <div class="block homeCon top">
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAFF0lEQVRYR82ZfUxVdRjHv78D8VL3Gi9a8uLUYXKg+kNexosrpzHSUVCEBZsbpcN4dSOoYaN1W0xhQbRByJsEoQhq6SRKc01jqfhCG2HARWWZdHEJVnKTywXOr/0O3rt7hcs59zLonr/Oznme5/c5z3Oel/M7BLYcKhUXqPUKFQi3EQKCAeoPwAuA8oG5UQBDAFGDQydHhTM9iqHLUKkEa5cj1iiszW7w4Th9JgXdRgBfa3QpMEhADgiCU3l/afIfcnVlAfIZ5Z7U1fljQul2AM5yjVuQG6eE1JGx8Q/6Ps8ckbIlCRiQXZ1IOZQBWCplzMr7w4SSzN5PU1rm0rMMqFI5+o96lxEg1cqFrRKnQKVaqcmCSjU5m+KsgL7Zh10V3N9HAMRYtZrtwm1awW3rYOnrYw+bmAmoUjnyo97HFxHOwNTWp9S88rAnZwD651TvW+iwWnK0GO6SnWmm980AHyTEIdsjNX9NQkmiaeIYAVkpgYtT3wJkq7XUw9DpeUMJMgL659ZUEErN3GvJ8qPOjyAzOhi8twccOE4SYGJqChf6Nag72wUqKQ1QQvapi1PSmagION0hxm/IKcK+7krsSdqAoFVP4ubwPQgCBQP2dleIS98auYcVnkvE89/u/IPJKQGODhxWLXscHdc1yKg7hfv6WSuKKfq4IDj7sY4jAvI5NXsBmif1cAyu9u0t8HJTIL3ue1weGAJA4feEO75+Jx4N7d0oPNGByh0vInyNDzYVNEE7rhf9kBgRgLzYCFwZGELq/pMyIElhX0nKbgKVivMf9b4p1Vs9FC5ozoqDj4cS26u+xcXrGvF5OEJQvG0TXnh6JTYWNOGuVid692BmLCpO/4yyU51GuaTIQOS/GilCvlnZhinBcsBZ71YrNStJYG5VmEBJh5T38mLDkfz8s9Dq9Gi+0CuGjR1ODg5gC4/pJ9B0vke87shxoscoKBrarxpldfpJpEatE/UKjp3HwXO/zrksR2g44d+tyYNA90oB1qfGIGyNt5SY7Pv1P/6CotaLc8tzZDfhc6uPguI1KcsNaTHwcVciurBFTAzDkREdJGZ05IeN+OtfnfE6C3n5W9HIP9yOry6pzcz3Fqegvr0bRSekAkeOEj6nqhsgz8gB9FC4Ir70GCYmp2YAhubXQ6ubMF4P9fPCl2kv4b1DZ9Haec1GQHqV8DnVd+QUZ+bBxQfEMANkcZEcQi0BpkWtw67NIQh6/wuMmdS39Wt9UbtzC7Ibf8DJrgEbPYjxeQMGr16OxvSX0d53C9913QB7PVlxTYoIAO/jiag9zRgZNZ+i5L+D04DzCjGrg2+E88iPXy/WRMPBvJlVfxrn+gdnvN5WALIQzy9J2OqMy/0xF6xe5gaOI2J7u3b7rlnSmFJaAdhN+JyaIwBNsDWLpfRmuy8fkJUZmYXaUpIsKCAr1HJb3f8BKLY6ucPCYgMahwUWIjnjFuvFS5XTnURv0klsCXHPJyniaFbUOlerM4xbMgfWjxKeQ1zIU0iu+AZdv/9pC5eosyFgBSp3bEZJ2yXUnumyZMd8YGVSUiM/m5hbdsWJ7Y5VO2JS8+TSUlbECaDWjCDhs+OYFGbfS5ox8othlvHRxEK8NYzHElfJzmiReUR7Hwd+6oFuwuLYP/tHE7No15+dhke26w93EdLetz4Yo31vHhlibc/bb6YpaL8bmCaUdr0FbOpNu91En1F1TX9DUBoCyn5DkOXmvyHobRCiBiFX5vMb4j+yk6vx/9TZwQAAAABJRU5ErkJggg=="
                />
                <div class="LeftB" style="border: 0px; display: inline-block">
                  <h4>总台数</h4>
                  <span>1798<small>台</small></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ReportDiv">
          <div class="el-row" style="margin-left: -12px; margin-right: -12px">
            <div
              class="el-col el-col-24 el-col-xs-24 el-col-sm-24 el-col-md-12"
              style="padding-left: 12px; padding-right: 12px"
            >
              <div class="block" style="position: relative; height: 300px">
                <h4>各型号总数占比</h4>
                <div
                  id="Kchart1a"
                  class="echarts"
                  _echarts_instance_="ec_1636595262888"
                  style="
                    height: 330px;
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    right: 0px;
                    -webkit-tap-highlight-color: transparent;
                    user-select: none;
                  "
                >
                  <div
                    style="
                      position: relative;
                      width: 930px;
                      height: 330px;
                      padding: 0px;
                      margin: 0px;
                      border-width: 0px;
                      cursor: pointer;
                    "
                  >
                    <canvas
                      data-zr-dom-id="zr_0"
                      width="1162"
                      height="412"
                      style="
                        position: absolute;
                        left: 0px;
                        top: 0px;
                        width: 930px;
                        height: 330px;
                        user-select: none;
                        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                        padding: 0px;
                        margin: 0px;
                        border-width: 0px;
                      "
                    ></canvas>
                  </div>
                  <div></div>
                </div>
              </div>
            </div>
            <div
              class="el-col el-col-24 el-col-xs-24 el-col-sm-24 el-col-md-12"
              style="padding-left: 12px; padding-right: 12px"
            >
              <div class="block" style="position: relative; height: 300px">
                <h4>各行业总数占比</h4>
                <div
                  id="Kchart2a"
                  class="echarts"
                  _echarts_instance_="ec_1636595262889"
                  style="
                    height: 330px;
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    right: 0px;
                    -webkit-tap-highlight-color: transparent;
                    user-select: none;
                  "
                >
                  <div
                    style="
                      position: relative;
                      width: 930px;
                      height: 330px;
                      padding: 0px;
                      margin: 0px;
                      border-width: 0px;
                      cursor: pointer;
                    "
                  >
                    <canvas
                      data-zr-dom-id="zr_0"
                      width="1162"
                      height="412"
                      style="
                        position: absolute;
                        left: 0px;
                        top: 0px;
                        width: 930px;
                        height: 330px;
                        user-select: none;
                        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                        padding: 0px;
                        margin: 0px;
                        border-width: 0px;
                      "
                    ></canvas>
                  </div>
                  <div></div>
                </div>
              </div>
            </div>
            <div
              class="el-col el-col-24 el-col-xs-24 el-col-sm-24 el-col-md-12"
              style="padding-left: 12px; padding-right: 12px"
            >
              <div class="block" style="position: relative; height: 300px">
                <h4>各区域总数占比</h4>
                <div
                  id="Kchart3a"
                  class="echarts"
                  _echarts_instance_="ec_1636595262890"
                  style="
                    height: 330px;
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    right: 0px;
                    -webkit-tap-highlight-color: transparent;
                    user-select: none;
                  "
                >
                  <div
                    style="
                      position: relative;
                      width: 930px;
                      height: 330px;
                      padding: 0px;
                      margin: 0px;
                      border-width: 0px;
                      cursor: default;
                    "
                  >
                    <canvas
                      data-zr-dom-id="zr_0"
                      width="1162"
                      height="412"
                      style="
                        position: absolute;
                        left: 0px;
                        top: 0px;
                        width: 930px;
                        height: 330px;
                        user-select: none;
                        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                        padding: 0px;
                        margin: 0px;
                        border-width: 0px;
                      "
                    ></canvas>
                  </div>
                  <div></div>
                </div>
              </div>
            </div>
            <div
              class="el-col el-col-24 el-col-xs-24 el-col-sm-24 el-col-md-12"
              style="padding-left: 12px; padding-right: 12px"
            >
              <div class="block" style="position: relative; height: 300px">
                <h4>各客户中心总数占比</h4>
                <div
                  id="Kchart4a"
                  class="echarts"
                  _echarts_instance_="ec_1636595262891"
                  style="
                    height: 330px;
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    right: 0px;
                    -webkit-tap-highlight-color: transparent;
                    user-select: none;
                  "
                >
                  <div
                    style="
                      position: relative;
                      width: 930px;
                      height: 330px;
                      padding: 0px;
                      margin: 0px;
                      border-width: 0px;
                      cursor: default;
                    "
                  >
                    <canvas
                      data-zr-dom-id="zr_0"
                      width="1162"
                      height="412"
                      style="
                        position: absolute;
                        left: 0px;
                        top: 0px;
                        width: 930px;
                        height: 330px;
                        user-select: none;
                        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                        padding: 0px;
                        margin: 0px;
                        border-width: 0px;
                      "
                    ></canvas>
                  </div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>   
<script>
export default {
  name: "index",
  data() {
    return {
      pickerBeginDateBefore: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      timeDefaultShow: "",
      pickerDate: "",
      formselect: {},
      airoptions: [],
      deviceStatuList: {
        1: "正常",
        2: "报警",
        3: "利用",
      },
      tableData1: [],
      GSNform: [],
      Linecolor: [
        "#28739A",
        "#51A470",
        "#FCBC5D",
        "#34A2BC",
        "#4A6AB5",
        "#6A6F89",
        "#CF554A",
        "#BECAD8",
        "#00A599",
        "#7AC3AB",
        "#689BA1",
        "#B9ECB0",
        "#9DA7E5",
      ],

      DataDeviceType: [],
      DataDeviceTypeWarning: [],

      DataIndustry: [],
      DataIndustryWarning: [],

      DataArea: [],
      DataAreaWarning: [],

      DataCenter: [],
      DataCenterWarning: [],
      StatisticsData: {
        tripCount: 0,
        totalCount: 0,
        currentCount: 0,
        rate: "",
      },
      UtilizationRate: "0%",
      DefaultUtilizationRate: "0%",
      monthList: [],
      monthData: null,
    };
  },
  async mounted() {
    let date = new Date();
    let year = date.getFullYear();
    let curMonth = date.getMonth();
    var curDate =
      curMonth >= 10 ? year + "-" + curMonth : year + "-0" + curMonth;
    this.monthData = curDate;
    this.monthList = [curDate, curDate];

    if (this.$route.params.times) {
      this.monthList = this.$route.params.times;
      this.monthData = this.$route.params.times;
    }
    this.StatisticsData = {
      totalCount: 1872,
      tripCount: 628,
      rate: "72.9",
      currentCount: 1798,
      warningAndTripCount: 760,
    };

    //if (type == "deviceModelTotalRate") {
    var data1 = {
      rate: null,
      ratePieList: [
        {
          value: 68.39,
          name: "螺杆机/微油变频",
        },
        {
          value: 64.78,
          name: "螺杆机/微油定频",
        },
        {
          value: 60.23,
          name: "螺杆机/无油变频",
        },
        {
          value: 54.82,
          name: "螺杆机/无油定频",
        },
      ],
      rateBarList: [
        {
          value: 47.95,
          name: "微油定频",
        },
        {
          value: 17.44,
          name: "无油定频",
        },
        {
          value: 17.38,
          name: "无油变频",
        },
        {
          value: 15.63,
          name: "微油变频",
        },
        {
          value: 1.38,
          name: "其他",
        },
      ],
    };
    this.DataDeviceType = data1.rateBarList;
    this.initPieDom("Kchart1a", this.DataDeviceType);
    //   this.DataDeviceTypeWarning = this.ratePieList;
    //   this.initBarDom("Kchart1b", this.DataDeviceTypeWarning);
    //} else if (type == "industryTotalRate") {

    var data2 = {
      rate: null,
      ratePieList: [
        {
          value: 74.84,
          name: "非金属制品",
        },
        {
          value: 66.74,
          name: "计算机及电子产品",
        },
        {
          value: 64.64,
          name: "其他采矿业（除油气）",
        },
        {
          value: 61.24,
          name: "公用事业",
        },
        {
          value: 53.02,
          name: "电气设备、电器及部件",
        },
        {
          value: 51.64,
          name: "机械",
        },
        {
          value: 51.24,
          name: "金属制品",
        },
        {
          value: 50.26,
          name: "原料金属",
        },
        {
          value: 48.06,
          name: "印刷及相关事务",
        },
        {
          value: 40.28,
          name: "其他",
        },
      ],
      rateBarList: [
        {
          value: 9.57,
          name: "计算机及电子产品",
        },
        {
          value: 7.39,
          name: "化学制品",
        },
        {
          value: 4.94,
          name: "运输设备",
        },
        {
          value: 4.25,
          name: "机械",
        },
        {
          value: 3.51,
          name: "食品",
        },
        {
          value: 3.4,
          name: "电气设备、电器及部件",
        },
        {
          value: 2.76,
          name: "非金属制品",
        },
        {
          value: 1.97,
          name: "原料金属",
        },
        {
          value: 1.65,
          name: "饮料和烟草",
        },
        {
          value: 51.78,
          name: "其他",
        },
      ],
    };
    this.DataIndustry = data2.rateBarList;
    this.initPieDom("Kchart2a", this.DataIndustry);
    //   this.DataIndustryWarning = data2.ratePieList;
    //   this.initBarDom("Kchart2b", this.DataIndustryWarning);
    //} else if (type == "regionTotalRate") {
    var data3 = {
      rate: null,
      ratePieList: [
        {
          value: 64.21,
          name: "华南",
        },
        {
          value: 63.88,
          name: "中西",
        },
        {
          value: 62.52,
          name: "华北",
        },
        {
          value: 60.39,
          name: "华东",
        },
        {
          value: 53.83,
          name: "东北",
        },
      ],
      rateBarList: [
        {
          value: 26.58,
          name: "华东",
        },
        {
          value: 17.54,
          name: "中西",
        },
        {
          value: 16.53,
          name: "华南",
        },
        {
          value: 14.78,
          name: "东北",
        },
        {
          value: 11.64,
          name: "华北",
        },
      ],
    };
    this.DataArea = data3.rateBarList;
    this.initPieDom("Kchart3a", this.DataArea);
    //   this.DataAreaWarning = data3.ratePieList;
    //   this.initBarDom("Kchart3b", this.DataAreaWarning);
    //} else if (type == "centerTotalRate") {
    var data4 = {
      rate: null,
      ratePieList: [
        {
          value: 74.82,
          name: "其他",
        },
        {
          value: 72.1,
          name: "福州",
        },
        {
          value: 71.04,
          name: "上海",
        },
        {
          value: 69.55,
          name: "广州",
        },
        {
          value: 68.55,
          name: "武汉",
        },
        {
          value: 67.37,
          name: "北京",
        },
        {
          value: 64.82,
          name: "南京",
        },
        {
          value: 64.65,
          name: "成都",
        },
        {
          value: 63.53,
          name: "深圳",
        },
        {
          value: 62.4,
          name: "济南",
        },
      ],
      rateBarList: [
        {
          value: 8.77,
          name: "苏州",
        },
        {
          value: 7.28,
          name: "武汉",
        },
        {
          value: 7.23,
          name: "广州",
        },
        {
          value: 6.86,
          name: "济南",
        },
        {
          value: 6.86,
          name: "南京",
        },
        {
          value: 6.86,
          name: "成都",
        },
        {
          value: 5.53,
          name: "杭州",
        },
        {
          value: 5.42,
          name: "上海",
        },
        {
          value: 4.94,
          name: "青岛",
        },
        {
          value: 4.84,
          name: "郑州",
        },
        {
          value: 4.78,
          name: "北京",
        },
        {
          value: 4.73,
          name: "深圳",
        },
        {
          value: 3.4,
          name: "西安",
        },
        {
          value: 2.98,
          name: "长春",
        },
        {
          value: 2.55,
          name: "福州",
        },
        {
          value: 2.02,
          name: "天津",
        },
        {
          value: 2.02,
          name: "昆明",
        },
        {
          value: 12.92,
          name: "其他",
        },
      ],
    };
    this.DataCenter = data4.rateBarList;
    this.initPieDom("Kchart4a", this.DataCenter);
    //   this.DataCenterWarning = data4.ratePieList;
    //   this.initBarDom("Kchart4b", this.DataCenterWarning);
    //}

    this.timeDefaultShow = new Date();
    this.timeDefaultShow.setMonth(new Date().getMonth() - 1);
  },
  methods: {
    initPieDom(dom, data) {
      var Kchart = this.$echarts.init(document.getElementById(dom));
      Kchart.setOption(this.initPie(data, this.$t("title.industryRatio")));
      window.addEventListener("resize", () => {
        Kchart.resize();
      });
    },
    initBarDom(dom, data) {
      var Kchart = this.$echarts.init(document.getElementById(dom));
      Kchart.setOption(this.initBar(data));
      window.addEventListener("resize", () => {
        Kchart.resize();
      });
    },

    initPie(Data, name) {
      var mWidth = 0;
      if (this.isCollapse) {
        mWidth = document.documentElement.clientWidth - 226;
      } else {
        mWidth = document.documentElement.clientWidth - 97;
      }
      mWidth = (mWidth - 150) / 4 - 30;

      var temp = {
        toolbox: {
          right: 30,
          top: 24,
          feature: {
            saveAsImage: {
              type: "png",
              icon: "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABpUlEQVQ4T92UIWwUQRSG/3+4NhU4BKKCeiSuioaEpAJHapqQq4PcbZsAitvZnd3ZQwFJu3cBx4WkhuAqmjRpisIh8SAQCByClGN+ciVt7mCPZqGKZ2fe9+a9/39DnHHwjHmYCiyKJ/PS7C1As5NFeUgevojjux+rHjMVmBflKwRdIfl+PFHSAgzfJnF0sxbQ+/IAwGtro2w80fsyBXDV2mjpPwA61z9vGt/XKc5IapIcVLV8fCbpWwjntpxrfTluf0KUong6HzR8B2AO5BsR3bTT3h+fVdbtXaPQgbQI4Kth43Ic3zlR/DeVs2xzicbs0piO7bQeVw3ed/v3FEJXISyn6cZIvJOotE2e91ZAbRuaZhy3tscTiqK/GhQGEFeTpP3y14JTfeh9GQl4ROiGtet7o0Tvt64L3CFw39qorGWb0eXMlw8JttEwPz03DAeCeqmNHkxb2VN3OS96zyEtHwHI3SRur/1p/08FOucaxlw4mlUIn1ecc8N/Atb9jSZe6H05AHCpJuSDtVGz0th5Xt4mcbEOUMKnJImeVQLrgP5a5bpFfgAK760Vi6b0CgAAAABJRU5ErkJggg==",
              iconStyle: {
                emphasis: {
                  textPosition: "left",
                  textFill: "#fff",
                },
              },
            },
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
          show: false,
          position: "left",
          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#fff",
            fontSize: 10,
            fontFamily: "Arial",
          },
        },
        legend: {
          type: "scroll",
          icon: "circle",
          orient: "vertical",
          left: "45%",
          top: 90,
          bottom: 15,
          right: 30,
          itemWidth: 8,
          itemHeight: 8,
          itemGap: 8,
          formatter: (name) => {
            return (
              // {name|' + item.name + '}
              "{name|" +
              this.$echarts.format.truncateText(name, mWidth, "…") +
              "} {percent|" +
              Data.find((item) => {
                return item.name == name;
              }).value +
              "%" +
              "}"
            );
          },
          tooltip: {
            show: true,
          },
          textStyle: {
            color: "#beceff", //元字颜色
            fontSize: 14,
            rich: {
              name: {
                color: "#fff",
                fontSize: 12,
                fontFamily: "Arial, 'microsoft yahei'",
                width: mWidth,
                align: "left",
              },
              percent: {
                color: "#fff",
                fontSize: 12,
                fontFamily: "Arial, 'microsoft yahei'",
                width: 50,
                align: "right",
              },
            },
          },

          pageIconSize: 10,
          pageTextStyle: {
            color: "#828393",
          },
        },
        series: [
          // {
          //   name: name,
          //   type: "pie",
          //   radius: ["0%", "55%"],
          //   center: ["24%", "60%"],
          //   color: "#393C46",
          //   itemStyle: {
          //     normal: {
          //       label: {
          //         show: false,
          //       },
          //       labelLine: {
          //         show: false,
          //       },
          //     },
          //   },
          //   hoverAnimation: false,
          //   data: [
          //     {
          //       value: 1,
          //     },
          //   ],
          //   z: 1,
          // },
          {
            name: "",
            type: "pie",
            radius: ["0%", "55%"],
            center: ["24%", "60%"],
            color: this.Linecolor,
            data: Data,
            labelLine: {
              show: false,
              length: 20,
              length2: 30,
            },

            label: {
              show: false,
              color: "#fff",
              lineHeight: 7,
              fontFamily: "Arial",
              formatter: function (params) {
                var percent = 0;
                var total = 0;
                for (var i = 0; i < Data.length; i++) {
                  total += Data[i].value;
                }
                percent = ((params.value / total) * 100).toFixed(0);
                if (params.name !== "") {
                  return params.name + ": " + percent + "%";
                } else {
                  return "";
                }
              },
            },
            z: 2,
          },
        ],
      };
      return temp;
    },
    initBar(Data) {
      var colorL = this.Linecolor;
      var temp = {
        toolbox: {
          right: 30,
          top: 24,
          feature: {
            saveAsImage: {
              type: "png",
              icon: "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABpUlEQVQ4T92UIWwUQRSG/3+4NhU4BKKCeiSuioaEpAJHapqQq4PcbZsAitvZnd3ZQwFJu3cBx4WkhuAqmjRpisIh8SAQCByClGN+ciVt7mCPZqGKZ2fe9+a9/39DnHHwjHmYCiyKJ/PS7C1As5NFeUgevojjux+rHjMVmBflKwRdIfl+PFHSAgzfJnF0sxbQ+/IAwGtro2w80fsyBXDV2mjpPwA61z9vGt/XKc5IapIcVLV8fCbpWwjntpxrfTluf0KUong6HzR8B2AO5BsR3bTT3h+fVdbtXaPQgbQI4Kth43Ic3zlR/DeVs2xzicbs0piO7bQeVw3ed/v3FEJXISyn6cZIvJOotE2e91ZAbRuaZhy3tscTiqK/GhQGEFeTpP3y14JTfeh9GQl4ROiGtet7o0Tvt64L3CFw39qorGWb0eXMlw8JttEwPz03DAeCeqmNHkxb2VN3OS96zyEtHwHI3SRur/1p/08FOucaxlw4mlUIn1ecc8N/Atb9jSZe6H05AHCpJuSDtVGz0th5Xt4mcbEOUMKnJImeVQLrgP5a5bpFfgAK760Vi6b0CgAAAABJRU5ErkJggg==",
              iconStyle: {
                emphasis: {
                  textPosition: "left",
                  textFill: "#fff",
                },
              },
            },
          },
        },
        grid: {
          top: 100,
          left: 40,
          right: 30,
          bottom: 0,
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: Data.map((item) => item.name),
            interval: 0,
            axisLabel: {
              textStyle: {
                margin: 5,
                color: "#828393",
                fontSize: 10,
                fontFamily: "Arial",
                lineHeight: 12,
              },
              interval: 0,
              formatter: function (params) {
                var newParamsName = ""; // 最终拼接成的字符串
                var paramsNameNumber = params.length; // 实际标签的个数
                var provideNumber = 6; // 每行能显示的字的个数
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
                /**
                 * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                 */
                // 条件等同于rowNumber>1
                if (paramsNameNumber > provideNumber) {
                  /** 循环每一行,p表示行 */
                  for (var p = 0; p < rowNumber; p++) {
                    var tempStr = ""; // 表示每一次截取的字符串
                    var start = p * provideNumber; // 开始截取的位置
                    var end = start + provideNumber; // 结束截取的位置
                    // 此处特殊处理最后一行的索引值
                    if (p == rowNumber - 1) {
                      // 最后一次不换行
                      tempStr = params.substring(start, paramsNameNumber);
                    } else {
                      // 每一次拼接字符串并换行
                      tempStr = params.substring(start, end) + "\n";
                    }
                    newParamsName += tempStr; // 最终拼成的字符串
                  }
                } else {
                  // 将旧标签的值赋给新标签
                  newParamsName = params;
                }
                //将最终的字符串返回
                return newParamsName;
              },
            },
            axisLine: {
              lineStyle: {
                color: "#3A3D46",
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            splitNumber: 5,
            axisLabel: {
              textStyle: {
                color: "#828393",
                fontSize: 10,
                fontFamily: "Arial",
              },
              formatter: "{value} %",
            },
            axisLine: {
              lineStyle: {
                color: "#3A3D46",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#3A3D46",
              },
            },
            max: 100,
            min: 0,
          },
        ],

        series: [
          {
            name: "故障率",
            type: "bar",
            barWidth: "35%",
            data: Data.map((item) => item.value),
            label: {
              show: true,
              position: "top",
              formatter: "{c}%",
              fontFamily: "Arial",
              textStyle: {
                color: "#fff",
              },
            },
            itemStyle: {
              normal: {
                barBorderRadius: [5, 5, 0, 0],
                color: "#28739A",
              },
            },
          },
        ],
      };
      return temp;
    },
  },
};
</script>
<style>
.theme1 {
  margin: 0;
}
</style>